import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthModule } from './auth/auth.module';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { CustomSerializer } from './router/custom-serializer';
import { EntityDataModule } from '@ngrx/data';
import * as RouterEffects from '@app/core/store/router/router.effects'

@NgModule({
  imports: [
    AuthModule,
    StoreModule.forRoot(
      {
          router: routerReducer
      }
    ),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
      serializer: CustomSerializer
    }),
    EffectsModule.forRoot([RouterEffects]),
    EntityDataModule.forRoot({}),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],

  exports: [],
  declarations: [],
  providers: []
})
export class AppStoreModule { }
